<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    style="z-index: 100"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayDate"
        :label="label"
        :placeholder="placeholder || $t('new-event.date-placeholder')"
        persistent-placeholder
        append-icon="mdi-calendar"
        class="rounded-lg"
        hide-details
        readonly
        v-bind="attrs"
        v-on="on"
        outlined
        dense
        :disabled="disabled"
        color="primary"
        :clearable="clearable"
        @click:clear="clearDates"
        :rules="rules"
      />
    </template>
    <v-date-picker
      locale="locale"
      color="primary"
      v-model="date"
      no-title
      scrollable
      :allowed-dates="allowedDates"
      :multiple="multiple"
    />
  </v-menu>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "DatePicker",

  props: {
    edit: [String, Array],
    label: {
      type: String,
      default: "",
    },
    allowedDates: {
      type: [Function, Array],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menu: false,
      date: this.multiple ? [] : null,
      displayDate: "",
      formattedDate: "",
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale.replace("_", "-");
    },
  },
  methods: {
    updateFormattedDate() {
      if (this.multiple && Array.isArray(this.date)) {
        this.displayDate = this.date
          .filter(date => dayjs(date).isValid())
          .map(date => dayjs(date).format("DD/MM/YYYY"))
          .join(", ");
        this.formattedDate = this.date
          .filter(date => dayjs(date).isValid())
          .map(date => dayjs(date).format("YYYY-MM-DD"));
      } else if (!this.multiple && dayjs(this.date).isValid()) {
        this.displayDate = dayjs(this.date).format("DD/MM/YYYY");
        this.formattedDate = dayjs(this.date).format("YYYY-MM-DD");
      } else {
        this.displayDate = "";
        this.formattedDate = "";
      }
      this.$emit("formatted-date", this.formattedDate);
    },
    handleEditDate() {
      if (this.multiple) {
        const dates = Array.isArray(this.edit)
          ? this.edit
          : this.edit.split(",");
        this.date = dates.map(date =>
          date.includes("/") ? date.split("/").reverse().join("-") : date
        );
      } else {
        this.date = this.edit.includes("/")
          ? this.edit.split("/").reverse().join("-")
          : this.edit;
      }
      this.updateFormattedDate();
    },
    clearDates() {
      this.date = this.multiple ? [] : null;
      this.displayDate = "";
      this.formattedDate = "";
      this.$emit("formatted-date", this.formattedDate);
      this.$emit("input", this.date);
    },
  },
  mounted() {
    if (this.edit) {
      this.handleEditDate();
    }
  },
  watch: {
    date() {
      this.updateFormattedDate();
    },
    menu(val) {
      if (!val) {
        this.updateFormattedDate();
      }
    },
    edit(newValue) {
      if (!newValue) {
        this.date = this.multiple ? [] : null;
        this.displayDate = "";
      }
    },
  },
};
</script>
